import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import BillAccountBatchFields from './BillAccountBatchFields'

export const BillAccountBatchCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <BillAccountBatchFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default BillAccountBatchCreate
